module.exports = __webpack_public_path__ + "static/img/octocat.38fdb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/octocat.png
// module id = 8sfF
// module chunks = 1